import type { FunctionComponent, MutableRefObject } from 'react';

import { Field, Form } from '@kanda-libs/ks-component-ts';
import {
  Button,
  Loader,
  ModalLayoutCenter,
} from '@kanda-libs/ks-design-library';

import { capitaliseWords } from 'common/helpers';

import { APR_CHANGED_OPTIONS } from './constants';

import { PropensioXidModalProps } from '..';
import {
  DEPOSIT_VALUE_VALIDATION,
  RATE_VALIDATION,
  REFERENCE_NUMBER_VALIDATION,
} from '../constants';
import usePropensioXidModalForm from '../usePropensioXidModalForm';

export interface PropensioXidModalFormProps extends PropensioXidModalProps {
  handleClose: () => void;
  ref?: MutableRefObject<HTMLElement | undefined>;
}

const PropensioXidModalForm: FunctionComponent<PropensioXidModalFormProps> =
  function ({ handleClose, ref, propensioCallback, setPropensioCallback }) {
    const { form, isSubmitting, onSubmit, aprChanged, rateOptions } =
      usePropensioXidModalForm(
        handleClose,
        propensioCallback,
        setPropensioCallback,
      );

    return (
      <>
        <ModalLayoutCenter
          id="staff-payment-propensio-xid"
          onClose={handleClose}
          ref={ref as MutableRefObject<HTMLDivElement>}
          className="w-10/12 p-4 md:w-160"
        >
          <Form
            id="staff-payment-propensio-xid"
            form={form}
            onSubmit={onSubmit}
            className="flex flex-col w-full"
          >
            <p className="mb-4 text-20-24-em">{`${capitaliseWords(
              propensioCallback || '',
            )} Finance`}</p>
            {propensioCallback === 'approve' && (
              <>
                <Field.Select
                  name="aprChanged"
                  label="Has the APR changed?"
                  options={APR_CHANGED_OPTIONS}
                />
                {aprChanged && (
                  <>
                    <Field.Validator validation={DEPOSIT_VALUE_VALIDATION}>
                      <Field.NumberInput
                        type="price"
                        name="deposit"
                        label="Deposit value"
                      />
                    </Field.Validator>
                  </>
                )}
                {aprChanged && (
                  <>
                    <Field.Validator validation={RATE_VALIDATION}>
                      <Field.Select
                        name="rate"
                        label="Select the new rate"
                        options={rateOptions}
                      />
                    </Field.Validator>
                  </>
                )}
              </>
            )}
            <p className="mb-6">Please provide the Propensio loan id:</p>
            <Field.Validator validation={REFERENCE_NUMBER_VALIDATION}>
              <Field.Input label="Propensio loan reference number" name="xid" />
            </Field.Validator>
            <Button.Text
              id="staff-payment-propensio-xid"
              submit
              disabled={isSubmitting}
              label="Submit"
              className="mx-auto"
            />
          </Form>
        </ModalLayoutCenter>
        <Loader isLoading={isSubmitting} />
      </>
    );
  };

export default PropensioXidModalForm;
